import React, { useEffect, useState } from 'react';
import { Field } from 'formik';
import AlertModal from 'web/components/AlertModal';
import RadioButton from 'web/components/form-elements/RadioButton';
import Button from 'web/components/Button';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import { SubHeading, StepTwoContainer, AccountTypeSection, ButtonWrapper } from 'web/pages/account/registration/corporate-Registration-Styled';

export default ({ props, nextCallBack, setFieldValue, callBackFun, pageLanguageContents }) => {

    const [buttonEnable, setButtonEnable] = useState(false)
    useEffect(() => {
        if(props.values?.drivingLicense !== '' || props.values?.taxId !== '') setButtonEnable(true)
        if(props.values?.buyerSellerOption === 'Buyer') setButtonEnable(true)
    }, [props])
    const { validateForm, setTouched } = props
    //To handle guest user upgrade signup
    const isGuestUserUpgrade = localStorage.getItem('guestUserUpgrade');
    const memberShipType = localStorage.getItem('memberShipType');

    useEffect(() => {
        //To handle accunt info for guest user upgrade signup
        if (isGuestUserUpgrade && memberShipType === 'broker') setFieldValue('reseller', 'active')
        else if (isGuestUserUpgrade && memberShipType === 'buyerSeller') {
            setFieldValue('reseller', 'deActive')
            setFieldValue('buyerSellerOption', 'Buyer & Seller')
        }
    },[isGuestUserUpgrade, memberShipType])

    let resellerOptions = [
        {
            name: pageLanguageContents?.Arrow3_Review[18]?.Yes,
            value: 'active',
            label: 'reseller',
        },
        {
            name: pageLanguageContents?.Arrow3_Review[19]?.No,
            value: 'deActive',
            label: 'reseller',
        }
    ]

    let buyerSellerOptions = ['Buyer', 'Seller', 'Buyer & Seller']

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    const clearField = () => {
        setFieldValue("taxId", "");
        setFieldValue("dnbNum", "");
        setFieldValue("creditRef", "");
        setFieldValue("paymentTerm", "30");
        setFieldValue("taxidLicense", "0");
        setFieldValue("drivingLicense", "");

        setFieldValue("ssn", "");
        setFieldValue("firstName", "");
        setFieldValue("lastName", "");
    }
    const onChangeHandler = () => {
        setFieldValue("accountHolderName", '')
        setFieldValue("bankAccount", '')
        setFieldValue("bankRouting", '')
        setFieldValue('buyerPaymentValidated', false)
        setFieldValue('sellerPaymentValidated', false)
        setFieldValue('membershipPaymentValidated', false)
        clearField()
        validateForm();
        setTouched({});
        callBackFun()
    };

    const [tooltipReseller, setTooltipReseller] = useState(false);
    const iIconReseller = (infoTxt) => {
        return <>
            <img
                id="tooltipReseller"
                src={information}
                style={{
                    paddingLeft: "5px",
                    position: "relative",
                    top: "-1px",
                }}
            />
            <Tooltip
                placement="right"
                isOpen={tooltipReseller}
                target="tooltipReseller"
                toggle={() =>
                    setTooltipReseller(!tooltipReseller)
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }


    return (
        <>
            <StepTwoContainer>
                <AccountTypeSection>
                    <SubHeading><img src={RightArrow} className='right-arrow' alt='right-arrow' />{pageLanguageContents?.Arrow2_Account[0]?.AccountTypes_Arrow}</SubHeading>
                    <div className="row mx-0">
                        <div className="col-12">
                            <div className="my-2 label-color">
                                <p>Do you buy or sell pallets on behalf of someone else? If so, choose Yes and register as a broker. Else, choose No.
                                    {iIconReseller('The broker classification is defined as a user that resells the services of pallet suppliers, and/or is responsible for sourcing pallets on the behalf of a customer.')}
                                </p>
                            </div>
                            <div className="d-flex">
                                {resellerOptions.map((optionValue, setIndex) => (
                                    <div key={setIndex} className="mr-2">
                                        <Field
                                            component={RadioButton}
                                            className="radio-label"
                                            name='reseller'
                                            id={optionValue.value}
                                            defaultValue={resellerOptions[0].value}
                                            onSelect={(e, props) => onChangeHandler()}
                                            label={optionValue.name}
                                            style={{ color: "black" }}
                                        />
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    </div>
                    {props.values.reseller === "deActive" &&
                        <div className="row mx-0">
                            <div className="col-12">
                                <div className="my-2 label-color">
                                    <p>Select Account Type<span class="star">*</span></p>
                                </div>
                                <div className="d-flex">
                                    {buyerSellerOptions.map((optionValue, setIndex) => (
                                        <div key={setIndex} className="mr-2">
                                            <Field
                                                component={RadioButton}
                                                className="radio-label"
                                                name='buyerSellerOption'
                                                id={optionValue}
                                                defaultValue={optionValue[0]}
                                                onSelect={(e, props) => onChangeHandler()}
                                                label={optionValue}
                                                style={{ color: "black" }}
                                            />
                                        </div>
                                    )
                                    )}
                                </div>
                            </div>
                        </div>
                    }
                    <ButtonWrapper className="step-2">
                        <Button
                            type="app-green-button submitBtn step-2"
                            disabled={(props.values?.membershipPaymentValidated && buttonEnable) ? false : true}
                            handleClick={() => nextCallBack()}
                        >
                            {pageLanguageContents?.Arrow3_Review[38]?.Next}
                        </Button>
                    </ButtonWrapper>
                </AccountTypeSection>
            </StepTwoContainer >

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=""
                content={modalContent}
                link={modalLink}
            />
        </>
    );
};
